var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-admin",
      attrs: { "default-active": "2", "active-text-color": "#3e10d5" }
    },
    [
      _c(
        "el-menu-item",
        { attrs: { index: "1004" }, on: { click: _vm.togglePhdRegistration } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-upload" }),
            _vm._v(" "),
            _c("span", [_vm._v("Καταχώριση Διδακτορικών στο ΕΑΔΔ")])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "1000" }, on: { click: _vm.toggleSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-search" }),
            _vm._v(" "),
            _c("span", [_vm._v("Αναζήτηση Αιτήσεων")])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aeb20af8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeb20af8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PhdRegistryMenu.vue
// module id = null
// module chunks = 